import { makeStyles } from '@material-ui/core/styles'
import { useBreakpoints } from 'commons/useBreakpoints'
import themesConfig from 'app/fuse-configs/themesConfig'

export default makeStyles((theme) => ({
  paidBlock: {
    minHeight: '60vh',
    display: 'flex',
    alignItems: 'center',
  },

  importTabsWrapper: {
    padding: 0,
    border: 0,
    outline: 'none',
    height: '100%',
    width: '100%',
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'column',
    minWidth: '250px',
    overflowY: 'auto',
  },

  tabsWrapper: {
    display: 'flex',
    [useBreakpoints(theme).lessThan.sm]: {
      flexDirection: 'column',
    },
  },

  tab: {
    display: 'flex',
    flex: 1,

    '& > input': {
      display: 'none',
    },

    '& > label': {
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      gap: '10px',
      width: '100%',
      border: 0,
      outline: 'none',
      cursor: 'pointer',
      padding: '20px',
      fontSize: '18px',
      lineHeight: 'normal',
      margin: '0 16.5px 8px 0',
      borderRadius: '6px',
      backgroundColor: themesConfig.default.colors.white,
      boxShadow: `0px 4px 14px 0px ${themesConfig.default.palette.grey.light}`,
      color: themesConfig.default.colors['grey-100'],
      transition: 'all 0.1s',
      '-o-transition': 'all 0.1s',
      '-ms-transition': 'all 0.1s',
      '-moz-transition': 'all 0.1s',
      '-webkit-transition': 'all 0.1s',

      [useBreakpoints(theme).lessThan.sm]: {
        margin: '0 0 10px 0',
      },

      '&.disabledTab': {
        cursor: 'default',
        pointerEvents: 'none',
        paddingRight: 50,

        '&::after': {
          content: '"Soon"',
          position: 'absolute',
          border: `1px solid ${themesConfig.default.colors['orange-600']}`,
          backgroundColor: themesConfig.default.colors['orange-50'],
          color: themesConfig.default.colors['orange-600'],
          top: 8,
          right: 8,
          fontWeight: 400,
          padding: '5px 6.5px',
          borderRadius: '6px',
          fontSize: 12,
          lineHeight: '17px',
        },
      },

      '& > .MuiListItemIcon-root': {
        minWidth: 'auto',
        width: '34px',
        marginRight: '10px',
      },
    },

    '&:last-child > label': {
      marginRight: 0,
    },
  },

  activeTab: {
    '& > label': {
      cursor: 'default',
      fontWeight: 700,
      borderBottomRightRadius: 0,
      borderBottomLeftRadius: 0,
      color: themesConfig.default.colors['neutrals-900'],
      boxShadow: `0px 1px 4px 0px ${themesConfig.default.palette.grey.light}`,
      [useBreakpoints(theme).moreThan.sm]: {
        marginBottom: 0,
        paddingBottom: '28px',
      },
    },
  },

  tabContentWrapper: {
    height: '100vh',
    listStyle: 'none',
    position: 'relative',
    display: 'block',
    overflow: 'auto',
    margin: 0,
    padding: 0,
    border: 0,
    outline: 'none',
    boxShadow: `0px 3px 3px 0px ${themesConfig.default.palette.grey.light}`,
    borderRadius: '0px 6px 6px 6px',
    background: themesConfig.default.colors.white,
  },

  infoTooltip: {
    maxWidth: '237px',
  },
}))
